<template :key="reload">
  <v-responsive>
    <v-container fill-height>
      <v-layout align-center mb-5>
        <v-flex>
          <h3 class="display-4">{{this.$t('global.login')}}</h3>
          <v-flex mt-5>
            <v-divider/>
            <v-text-field solo light v-model="email" label="Email"/>
            <v-text-field type="password" v-model="password" solo light label="Password"/>
            <v-btn primary blue large @click="login()">Log in</v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-snackbar
      v-model="snackbar"
      color="error"
      top
      xs12
      :multi-line="true"
      :timeout="10000"
      >
        {{error}}
      </v-snackbar>
    </v-container>
  </v-responsive>
</template>
<script>
import axios from 'axios'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev
import jwtDecode from 'jwt-decode'
axios.defaults.baseURL = apiUrl

export default {
  data () {
    return {
      error: 'Error',
      email: '',
      password: '',
      brand: 0,
      reload: 0,
      snackbar: false
    }
  },
  methods: {
    login: function () {
      axios.post('/signin', { email: this.email, password: this.password })
        .then((element) => {
          if (element.data.success === true) {
            var decoded = jwtDecode(element.data.data[0].token)
            this.$session.start()
            this.$session.set('jwt', decoded)
            this.$session.set('brand', (decoded.brand === 'ysl' ? 2 : 1))
            this.$session.set('token', element.data.data[0].token)
            this.$session.set('catalog', decoded.catalog)
            localStorage.token = element.data.data[0].token
            localStorage.brand = (decoded.brand === 'ysl' ? 2 : 1)
            localStorage.permission = decoded.permission
            localStorage.isLogged = true
            localStorage.catalog = decoded.catalog
            this.reload++
            this.$router.push('/')
          } else {
            this.error = 'Email or password incorrect'
            this.snackbar = true
          }
        })
        .catch(() => {
          this.error = 'The data format seems incorrect'
          this.snackbar = true
        })
    },
    logout: function () {
      let instance = axios.create({
        headers: { 'Authorization': 'Bearer ' + localStorage.token }
      });
      instance.get('/' + this.$session.get('brand') + '/logout')
      .then(() => {
        this.$session.destroy()
        localStorage.clear()
        this.reload++
      }).catch(console.log)

    }
  }
}
</script>

<style>

</style>
